module.exports = __webpack_public_path__ + "static/media/fwf_logo_szare.952f6017.png";